import styled from '@emotion/styled';
import { colors } from '@/styles';
import { Body1 } from '../blocks';

export const EmailHeading = styled.span`
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    color: ${colors.greys[3]};
`;

export const SectionHeading = styled.span`
    font-weight: 700;
    font-size: 14px;
    color: ${colors.greys.secondary};
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;

export const OptionName = styled.span`
    font-weight: 600;
    font-size: 14px;
    color: ${colors.greys[3]};
`;

// white-space is reset because the Autocomplete option row sets nowrap, which would clip the
// description to a single line.
export const OptionDescription = styled(Body1)`
    font-size: 0.8125rem;
    color: ${colors.greys.secondary};
    white-space: normal;
`;

export const CheckboxDescription = styled(Body1)`
    margin-left: 32px;
    font-size: 0.875rem;
    color: ${colors.greys.secondary};
`;
